import { OptimizelyFeatureFlags } from 'constants/optimizely'

function getIsLoyaltyPurchasePointsEnabled(state: App.State): boolean {
  return !!state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.loyaltyPurchasePointsEnabled]
}

export default getIsLoyaltyPurchasePointsEnabled
